export default __webpack_public_path__ + "static/media/Group 201.bdb75640.png";